module.exports = __webpack_public_path__ + "media/images/emp/nist_logo_doc_b-c930126a5cc4af0c29b31c3382d061af.png";